<template>
  <div>
    <div class="d-flex align-center justify-lg-space-between">
      <div>
        <div class="text-right d-flex justify-space-between mb-5">
          <v-btn color="primary" v-bind="$attrs" @click="clearCells()">
            <v-icon left>mdi-chevron-left</v-icon>
            {{ $t("prev") }}
          </v-btn>
        </div>
        <div class="d-flex align-center">
          <h3 class="text--secondary my-2">{{ $t("warehouse") }} :</h3>
          <h4 class="ml-2">
            {{ warehouse.warehouseName }} / {{ warehouse.column
            }}{{ warehouse.row }}
          </h4>
        </div>
      </div>
      <v-alert border="right" colored-border type="info" elevation="2">
        {{ $t("hint") }}: {{ $t("rightClickingMouse") }}
      </v-alert>
    </div>

    <OmtkStillageView
      ref="omtkStillageViewRef"
      :data="boardData"
      :warehouse="warehouse"
      :productItemIds="productItemIds"
      :fromWarehouseId="fromWarehouseId"
      :toWarehouseId="toWarehouseId"
      :selectedProductId="selectedProductId"
      @update="getBoard"
      @place-here="$emit('place-here')"
      @clearProductItemIds="$emit('clearProductItemIds')"
    />
  </div>
</template>

<script>
import OmtkStillageView from "@/components/omtk/OmtkStillageView.vue";
import { getQueryByKey } from "@/utils/pureFunctions";
import { BoxService } from "@/services/BoxService.js";
import { DEFAULT_STILLAGE_BOX_SIZE } from "@/utils/constants.js";

export default {
  components: { OmtkStillageView },
  props: {
    cellId: {},
    productItemIds: {
      type: Array,
      required: true,
    },
    fromWarehouseId: {
      type: String,
    },
    toWarehouseId: {
      type: String,
    },
    selectedProductId: {
      type: String,
    },
  },
  data() {
    return {
      nameFilterProduct: null,
      boardData: {
        columns: [],
        boards: [],
        rows: [],
      },
      warehouse: {
        warehouseName: null,
        column: null,
        row: null,
      },
    };
  },
  methods: {
    async getBoard() {
      try {
        const { cellId } = this;
        const {
          data: { data },
        } = await this.$http.get("stillage/board", {
          params: { cellId, term: this.nameFilterProduct },
        });
        const boxService = new BoxService(DEFAULT_STILLAGE_BOX_SIZE);
        this.boardData = {
          ...boxService.parseData(data),
        };
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async warehouseStillageName() {
      try {
        const {
          data: { data },
        } = await this.$http.get("stillage/info-by-cell", {
          params: {
            cellId: this.cellId,
          },
        });
        if (data) {
          this.warehouse = getQueryByKey(this.warehouse, data);
        }
      } catch (err) {
        this.setResponseError({ error: err });
      }
    },
    clearCells() {
      this.$emit("showStillage");
      this.$refs.omtkStillageViewRef.clearSelectedCells();
    },
  },
  async created() {
    if (this.$route.query.productName) {
      this.nameFilterProduct = this.$route.query.productName;
    }
    this.showLoading();
    await this.getBoard();
    await this.warehouseStillageName();
    this.clearLoading();
  },
};
</script>
